import { APP_INITIALIZER, Provider } from '@angular/core';

import { FeatureFlagsProvider } from '@shared/providers';

export function initializeFeatureFlagFactory(
  featureFlagProvider: FeatureFlagsProvider,
): () => Promise<void> {
  return () => featureFlagProvider.loadFeatureFlags();
}

export const provideFeatureFlag = (): Provider => ({
  provide: APP_INITIALIZER,
  useFactory: initializeFeatureFlagFactory,
  deps: [FeatureFlagsProvider],
  multi: true,
});
